<style scoped>

.HomeBackground {
  height: 100vh;
  background: #00919C;
  background: linear-gradient(45deg, #00919c 15%, #43D5D9 50%);
  overflow: hidden;
  position: relative;
  border-radius: 0 0 0 0;
  transition: border-radius 500ms;
}

.HomeBackground-animated.HomeBackground {
  border-radius: 0 0 0 200px;
}

.HomeBackground-mobile.HomeBackground {
  border-radius: 0 0 50px 50px;
  background: linear-gradient(45deg, #00919c 15%, #43D5D9 50%);
}

.HomeBackground--forms {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.HomeBackground-mobile .HomeBackground--forms {
  display: none;
}

.HomeBackground--form {
  position: absolute;
  width: 600px;
  height: 275px;
  border-radius: 10000px;
  background: rgba(255, 255, 255, 0.1);
}

.HomeBackground--form-1 {
  top: 0;
  left: 0;
  top: -150px;
  left: -100px;
  transform: rotate(0) translate(-100%, -100%);
  transition: transform 500ms;
}

.HomeBackground-animated .HomeBackground--form-1 {
  transform: rotate(-45deg) translate(0, 0);
}

.HomeBackground--form-2 {
  top: -150px;
  left: 35%;
  transform: rotate(-45deg) translate(100%, -100%);
  transition: transform 500ms;
}

.HomeBackground-animated .HomeBackground--form-2 {
  transform: rotate(-45deg) translate(0, 0);
}


.HomeBackground--form-3 {
  bottom: -250px;
  left: 0;
  transform: rotate(-45deg) translate(0, 100%);
  transition: transform 500ms;
}

.HomeBackground-animated .HomeBackground--form-3 {
  transform: rotate(-45deg) translate(0, 0);
}


.HomeBackground--form-4 {
  position: absolute;
  bottom: 50%;
  left: 0;
  margin-bottom: -450px;
  opacity: 0;
  transform: scale(3) rotate(0deg) translate(0, 0);
  transition: transform 500ms, opacity 500ms;
  transition-delay: 500ms;
}

.HomeBackground-animated .HomeBackground--form-4 {
  opacity: 1;
  transform: scale(1.5) rotate(0deg) translate(0, 0);
}

.HomeBackground--photoWhite {
  height: 100vh;
  width: 30vw;
  background: #ffffff;
  position: absolute;
  bottom: 0;
  right: 0;
}

.HomeBackground-mobile .HomeBackground--photoWhite {
  display: none;
}


.HomeBackground--photoCalc {
  height: 110vh;
  width: 60vw;
  background: rgba(255, 255, 255, 0.25);
  position: absolute;
  top: -1%;
  left: 36%;
  border-radius: 10000px 0 10000px 10000px;
  transform: rotate(45deg);
  transition: transform 500ms;
  transition-delay: 500ms;
}

.HomeBackground-animated .HomeBackground--photoCalc {
  opacity: 1;
  transform: rotate(0deg);
}

.HomeBackground-mobile .HomeBackground--photoCalc {
  display: none;
}

.HomeBackground--photo {
  height: 100vh;
  width: 60vw;
  background: #000000;
  position: absolute;
  left: 40%;
  border-radius: 10000px 0 0 10000px;
  overflow: hidden;
  background: linear-gradient(45deg, #bde3f6 0%, #a0d3ee 75%);
  display: flex;
  justify-content: center;
  align-items: flex-end;
  transition: border-radius 500ms;
}

.HomeBackground-animated .HomeBackground--photo {
  border-radius: 10000px 0 10000px 10000px;
}

.HomeBackground-desktop .HomeBackground--photo {
  bottom: 0;
}

.HomeBackground-tablet .HomeBackground--photo {
  bottom: 0;
}

.HomeBackground-mobile .HomeBackground--photo {
  height: calc(100vh - 100px);
  width: 100vw;
  top: 0;
  left: 0%;
  border-radius: 0 0 10000px 0px;
}

.HomeBackground--logo {
  position: absolute;
  top: 58px;
  left: 0;
  height: 40vh;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  opacity: 0;
  transition: opacity 1000ms, transform 500ms;
  transition-delay: 1500ms;
  transform: translate(0, -15px);
}

.HomeBackground-animated .HomeBackground--logo {
  opacity: 1;
  transform: translate(0, 0);
}

.HomeBackground--logoVector {
  width: 250px;
}

.HomeBackground-mobile .HomeBackground--logoVector {
  width: 150px;
  position: absolute;
  top: -15px;
  right: 50px;
}

.HomeBackground--photo img {
  position: absolute;
  height: 60vh;
  opacity: 0;
  transform: scale(3) translate(0, 100%);
  transition: transform 750ms, opacity 1000ms;
  transition-delay: 500ms;
}

.HomeBackground-animated .HomeBackground--photo img {
  opacity: 1;
  transform: scale(1) translate(0, 0);
}

.HomeBackground-mobile .HomeBackground--photo img {
  height: 40vh;
}

.HomeBackground--infos {
  position: absolute;
  top: 0;
  left: 0;
  width: 40vw;
  height: 100vh;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
}

.HomeBackground-desktop .HomeBackground--infos {
  padding-left: 250px;
}

.HomeBackground-tablet .HomeBackground--infos {
  padding-left: 15%;
}

.HomeBackground-mobile .HomeBackground--infos {
  width: 100vw;
  height: 40vh;
  align-items: center;
  padding-right: 0px;
  padding-top: 100px;
  justify-content: center;
  position: initial;
}

.HomeBackground--infos >>> .Button {
  background: #24b5bd;
  margin-top: 65px;
  padding: 15px 75px;
  box-shadow: 0 20px 30px rgba(119, 119, 119, 0.25);
}

.HomeBackground-tablet .HomeBackground--button >>> .Button {
  margin-top: 50px;
  padding: 15px 50px;
}

.HomeBackground--button {
  text-decoration: none;
}


.HomeBackground-mobile .HomeBackground--button {
  position: absolute;
  bottom: 25px;
}

.HomeBackground-mobile .HomeBackground--button >>> .Button {
  background: #2cbec4;
}

.HomeBackground--title {
  font-family: 'GothamBold', sans-serif;
  font-size: 40px;
  line-height: 50px;
  color: #ffffff;
  position: relative;
  margin-bottom: 5px;
}

.HomeBackground-tablet .HomeBackground--title {
  font-size: 25px;
  line-height: 40px;
  margin-bottom: 5px;
}

.HomeBackground-mobile .HomeBackground--title {
  font-size: 20px;
  line-height: 30px;
  margin-bottom: 0px;
}

.HomeBackground--titleLine {
  width: 4px;
  border-radius: 4px;
  height: 60%;
  background: #ffffff;
  position: absolute;
  top: 20%;
}

.HomeBackground-desktop .HomeBackground--titleLine {
  left: -30px;
}

.HomeBackground-tablet .HomeBackground--titleLine {
  left: -30px;
}

.HomeBackground-mobile .HomeBackground--titleLine {
  display: none;
}

.HomeBackground--titlePoint {
  width: 4px;
  height: 4px;
  background: #ffffff;
  position: absolute;
  bottom: 0;
  left: 0;
  border-radius: 4px;
  opacity: 0;
  transition: opacity 500ms;
  animation: HomeBackground--animation 2000ms infinite;
}

.HomeBackground--titlePoint-1 {
  bottom: -10px;
}

.HomeBackground--titlePoint-2 {
  bottom: -20px;
  animation-delay: 500ms;
}

a {
  text-decoration: none;
}

@keyframes HomeBackground--animation {
  0% {
    opacity: 0;
  }
  50% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}
</style>

<template>
  <div class="HomeBackground" :class="class_root">
    <Responsive :breakPoint="state.props.Responsive['0'].breakPoint"
                :verticalBreakPoint="state.props.Responsive['0'].verticalBreakPoint"
                :breakPoints="state.props.Responsive['0'].breakPoints"
                :verticalBreakPoints="state.props.Responsive['0'].verticalBreakPoints"
                :onBreakPointChange="state.props.Responsive['0'].onBreakPointChange"
                :onVerticalBreakPointChange="state.props.Responsive['0'].onVerticalBreakPointChange">
      <div class="HomeBackground--forms">
        <div class="HomeBackground--form HomeBackground--form-1"></div>
        <div class="HomeBackground--form HomeBackground--form-2"></div>
        <div class="HomeBackground--form HomeBackground--form-3"></div>
        <div class="HomeBackground--form-4">
          <Grid></Grid>
        </div>
      </div>
      <div class="HomeBackground--photoWhite">
      </div>
      <div class="HomeBackground--photoCalc">
      </div>
      <div class="HomeBackground--photo">
        <div class="HomeBackground--logo">
          <div class="HomeBackground--logoVector">
            <Vector :svg="svg.logo"></Vector>
          </div>
        </div>
        <img @load="onLoaded" :src="img.background" alt="JobStream Background">
      </div>
      <div class="HomeBackground--infos">
        <div class="HomeBackground--title">
          <Animation :delay="100">Comprendre</Animation>
          <div class="HomeBackground--titleLine">
            <div class="HomeBackground--titlePoint HomeBackground--titlePoint-1"></div>
            <div class="HomeBackground--titlePoint HomeBackground--titlePoint-2"></div>
          </div>
        </div>
        <div class="HomeBackground--title">
          <Animation :delay="200">Apprendre</Animation>
        </div>
        <div class="HomeBackground--title">
          <Animation :delay="300">Entreprendre</Animation>
        </div>
        <div class="HomeBackground--button">
          <Animation>
            <router-link to="/nous-connaitre/jobstream" @click.native="$scrollToTop();">
              <Button>
                Découvrir
              </Button>
            </router-link>
          </Animation>
        </div>
      </div>
    </Responsive>
  </div>
</template>

<script>

// -----

import BreakPoint from '@bbx/responsive~master/core/delta/BreakPoint';
import SCREEN from '@bbx/responsive~master/core/constant/SCREEN';
import {ListenerRegister} from "@bbx/listener~master/core/delta/ListenerRegister";
import {ListenerTrigger} from "@bbx/listener~master/core/delta/ListenerTrigger";
import {eventService} from "../../service/eventService";
import {EVENT} from "../../constant/EVENT";

// -----

export default {
  props: {},
  data() {
    return {
      icon: {
        tune: require('@bbx/vector~master/core/assets/svg/material/tune.svg'),
      },
      svg: {
        logo: require('../../../../assets/logo/logo.svg'),
      },
      img: {
        background: require('../../../../assets/photo/accueil-background-sd.png')
      },
      state: {
        props: {
          Responsive: {
            "0": {
              breakPoint: new BreakPoint({
                name: SCREEN.DESKTOP
              }),
              verticalBreakPoint: new BreakPoint(),
              breakPoints: [
                new BreakPoint({
                  name: SCREEN.MOBILE,
                  width: 0
                }),
                new BreakPoint({
                  name: SCREEN.TABLET,
                  width: 900
                }),
                new BreakPoint({
                  name: SCREEN.DESKTOP,
                  width: 1440
                }),
              ],
              verticalBreakPoints: [
                new BreakPoint({
                  name: SCREEN.MOBILE,
                  height: 0
                }),
                new BreakPoint({
                  name: SCREEN.DESKTOP,
                  height: 600
                }),
              ],
              onBreakPointChange: (v) => this.state.props.Responsive['0'].breakPoint = v,
              onVerticalBreakPointChange: (v) => this.state.props.Responsive['0'].verticalBreakPoint = v,
            },
          },
        },
        animated: false,
        loaded: false,
      },
      events: []
    }
  },
  watch: {},
  computed: {
    class_root() {
      const classes = []
      if (this.state.props.Responsive['0'].breakPoint.name === SCREEN.MOBILE) classes.push(`HomeBackground-mobile`)
      if (this.state.props.Responsive['0'].breakPoint.name === SCREEN.TABLET) classes.push(`HomeBackground-tablet`)
      if (this.state.props.Responsive['0'].breakPoint.name === SCREEN.DESKTOP) classes.push(`HomeBackground-desktop`)
      if (this.state.props.Responsive['0'].verticalBreakPoint.name === SCREEN.MOBILE) classes.push(`HomeBackground-mobileY`)
      if (this.state.props.Responsive['0'].verticalBreakPoint.name === SCREEN.DESKTOP) classes.push(`HomeBackground-desktopY`)
      if (this.state.animated) classes.push(`HomeBackground-animated`)
      return classes
    }
  },
  beforeMount() {
    this.events.push(new ListenerRegister({
      name: EVENT.START_ANIMATION,
      callback: () => {
        setTimeout(() => this.start(), 3000)
      }
    }))

    // -----

    for (const event of this.events) {
      eventService.register(event)
    }
  },
  mounted() {
  },
  beforeDestroy() {
    for (const event of this.events) {
      eventService.unregister(event)
    }
  },
  methods: {
    start() {
      this.state.animated = true
    },
    onLoaded() {
      this.state.loaded = true
      this.start()
    }
  }
}
</script>